import { render, staticRenderFns } from "./RenameQuery.vue?vue&type=template&id=14595aaf&scoped=true&"
import script from "./RenameQuery.vue?vue&type=script&lang=js&"
export * from "./RenameQuery.vue?vue&type=script&lang=js&"
import style1 from "./RenameQuery.vue?vue&type=style&index=1&id=14595aaf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14595aaf",
  null
  
)

export default component.exports